import React, { useState, useEffect } from "react";
import "../App.css";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { Select } from "antd";
import { getRoute } from "../api/routes";
import api from "../Interceptor";
import { useDispatch, useSelector } from "react-redux";
import ExpenseGraph from "../components/ExpenseGraph";
import Admin_UserStatusGraph from "../components/Admin_UserStatusGraph";
import Admin_RecentTransactions from "../components/Admin_RecentTransactions";
import GetCurrencySymbol from "../components/GetCurrencySymbol";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { calculateTotals } from "../utils/calculateTotals";
import { calculateDuration } from "../utils/calculateDuration";
import { durationOptions } from "../utils/filters";
import useProjectExpenses from "../hooks/useProjectExpenses";
import { fetchAllCurrencies } from "../features/currency/currencyActions";
import { AllExpenses } from "../api/services/allExpenses";
import { fetchAllExpenses } from "../features/expenses/expenseActions";
import QuickActions from "../components/QuickActions";
import {
  // faRefresh,
  faArrowTrendUp,
  faArrowTrendDown,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import TrialBadge from "../components/TrialBadge";

const { Option } = Select;

const Dashboard = () => {
  const user = useSelector((state) => state.auth.user);
  const { expenses } = useSelector((state) => state.expense);
  const baseCurrency = localStorage.getItem("baseCurrency");

  const dispatch = useDispatch();
  const symbol = useSelector(
    (state) =>
      state.currency.currencies.find(
        (c) => c._id === localStorage.getItem("baseCurrency"),
      )?.symbol || "N/A",
  );
  const {
    income: totalIncome,
    expense: totalExpense,
    netProfit,
  } = calculateTotals(expenses);

  const { projectList } = useSelector((state) => state.app);
  const [milestoneList, setMilestoneList] = useState([]);
  const [selectedProject, setSelectedProject] = useState("All");
  const [selectedMilestone, setSelectedMilestone] = useState("All");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [loading, setLoading] = useState(false);
  const [selectedDuration, setSelectedDuration] = useState("all");
  useEffect(() => {
    const { newStartDate, newEndDate } = calculateDuration("all");

    setStartDate(newStartDate);
    setEndDate(newEndDate);
  }, []);

  const fetchMilestones = async (projectId) => {
    try {
      const response = await api.get(
        `${getRoute(
          "users",
          "admin",
          "projects",
          false,
          false,
          "milestone",
        )}?projectId=${projectId}`,
      );
      setMilestoneList(response.data);
    } catch (error) {
      toast.error("Error fetching milestones", error);
      return null;
    }
  };

  const handleProjectChange = (value) => {
    setSelectedProject(value);
    if (value !== "All") {
      fetchMilestones(value);
    } else {
      setMilestoneList([]);
    }
  };

  const handleMilestoneChange = (value) => {
    setSelectedMilestone(value);
  };
  const handleDurationChange = (value) => {
    setSelectedDuration(value);
    const { newStartDate, newEndDate } = calculateDuration(value);
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };

  const handleRefresh = () => {
    setSelectedDuration("all");
    setSelectedProject("All");
    setSelectedMilestone("All");
    const { newStartDate, newEndDate } = calculateDuration("all");
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };
  // useEffect(() => {
  //   fetchAllCurrencies(dispatch)
  // }, [dispatch])
  useEffect(() => {
    if (user?.userRole?.name) {
      dispatch(fetchAllExpenses({ userRole: user.userRole.name }));
    }
  }, [dispatch, user]);
  if (loading)
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );

  return (
    <div className="min-h-screen grid grid-rows-[auto_auto_1fr_1fr] gap-2 p-3 overflow-hidden font-customFont">
      <div className="flex-shrink-0 h-[40px] flex flex-col md:flex-row justify-between items-start md:items-center">
        <div
          style={{ fontFamily: "Noto Serif, sans-serif" }}
          className="mb-4 md:mb-0"
        >
          <h1 className="font-bold text-lg md:text-xl text-gray-800">
            Dashboard
          </h1>
          <p className="text-xs text-gray-500 font-semibold">
            Welcome back! Here's your financial overview
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {/* Total Net Income Card */}{" "}
        <div className="group relative overflow-hidden border border-blue-200 bg-gradient-to-br from-blue-50 via-white to-blue-100 shadow-lg  transition-all duration-300 rounded-xl p-4 pb-3 flex flex-col sm:col-span-2 lg:col-span-1">
          <div className="absolute top-0 right-0 w-32 h-32 bg-blue-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center shadow-md">
                <FontAwesomeIcon
                  icon={faWallet}
                  className="text-white text-md"
                />
              </div>
              <p className="text-blue-700 text-sm font-semibold uppercase tracking-wide">
                Net Income
              </p>
            </div>
          </div>
          <p className="text-blue-900 text-3xl font-bold mt-1 relative z-10">
            <GetCurrencySymbol currencyId={baseCurrency} />{" "}
            <span>{Math.floor(netProfit).toLocaleString()}</span>
            <span className="text-blue-600 text-xl">
              .{netProfit.toFixed(2).split(".")[1]}
            </span>
          </p>
          <p className="text-blue-600 text-xs mt-1 font-medium">
            Total profit after expenses
          </p>
        </div>
        {/* Total Income Card */}{" "}
        <div className="group relative overflow-hidden border border-green-200 bg-gradient-to-br from-green-50 via-white to-green-100 shadow-lg  transition-all duration-300 rounded-xl p-4 pb-3 flex flex-col ">
          <div className="absolute top-0 right-0 w-32 h-32 bg-green-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-green-500 to-green-700 flex items-center justify-center shadow-md">
                <FontAwesomeIcon
                  icon={faArrowTrendUp}
                  className="text-white text-md"
                />
              </div>
              <p className="text-green-700 text-sm font-semibold uppercase tracking-wide">
                Income
              </p>
            </div>
          </div>
          <p className="text-green-900 text-3xl font-bold mt-2 relative z-10">
            <GetCurrencySymbol currencyId={baseCurrency} />{" "}
            <span>{Math.floor(totalIncome).toLocaleString()}</span>
            <span className="text-green-600 text-xl">
              .{totalIncome.toFixed(2).split(".")[1]}
            </span>
          </p>
          <p className="text-green-600 text-xs mt-1 font-medium">
            Total earnings received
          </p>
        </div>
        {/* Total Expense Card */}{" "}
        <div className="group relative overflow-hidden border border-red-200 bg-gradient-to-br from-red-50 via-white to-red-100 shadow-lg transition-all duration-300 rounded-2xl p-4 pb-3 flex flex-col">
          <div className="absolute top-0 right-0 w-32 h-32 bg-red-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-red-500 to-red-700 flex items-center justify-center shadow-md">
                <FontAwesomeIcon
                  icon={faArrowTrendDown}
                  className="text-white text-md"
                />
              </div>
              <p className="text-red-700 text-sm font-semibold uppercase tracking-wide">
                Expense
              </p>
            </div>
          </div>
          <p className="text-red-900 text-3xl font-bold mt-2 relative z-10">
            <GetCurrencySymbol currencyId={baseCurrency} />{" "}
            <span>{Math.floor(totalExpense).toLocaleString()}</span>
            <span className="text-red-600 text-xl">
              .{totalExpense.toFixed(2).split(".")[1]}
            </span>
          </p>
          <p className="text-red-600 text-xs mt-1 font-medium">
            Total amount spent
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-2 min-h-[400px] lg:h-full lg:min-h-0">
        <div className="lg:col-span-7 h-[400px] lg:h-full min-h-0">
          <div className="w-full h-full rounded-xl bg-white border border-[#D5D7DA] shadow-lg p-3 flex flex-col">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-2 flex-shrink-0">
              <p className="font-semibold font-customFont text-center sm:text-left w-full md:w-auto">
                Overview
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:flex gap-2 w-full md:w-auto font-customFont">
                <Select
                  defaultValue="All"
                  id="filterProject"
                  value={selectedProject}
                  onChange={(value) => handleProjectChange(value)}
                  className={`ring-1 rounded-md w-full sm:w-40 ${
                    selectedProject || selectedProject === "All"
                      ? ""
                      : "ring-blue-400"
                  }`}
                >
                  <Option value="All">All Projects</Option>
                  {projectList.map((pro) => (
                    <Option key={pro?._id} value={pro?._id}>
                      {pro?.name}
                    </Option>
                  ))}
                </Select>
                <Select
                  defaultValue="All"
                  id="filterMilestone"
                  value={selectedMilestone}
                  disabled={selectedProject === "All"}
                  onChange={(value) => handleMilestoneChange(value)}
                  className={`ring-1 rounded-md w-full sm:w-40 ${
                    selectedMilestone || selectedMilestone === "All"
                      ? ""
                      : "ring-blue-400"
                  }`}
                >
                  <Option value="All">All Milestones</Option>
                  {milestoneList.map((mile) => (
                    <Option key={mile._id} value={mile._id}>
                      {mile.name}
                    </Option>
                  ))}
                </Select>

                <Select
                  value={selectedDuration}
                  onChange={handleDurationChange}
                  className={`w-full sm:w-40 ${
                    selectedDuration
                      ? "ring-1 ring-blue-400  sm:col-span-2 lg:col-span-1 rounded-md"
                      : ""
                  }`}
                >
                  {durationOptions.map((opt) => (
                    <Option key={opt.value} value={opt.value}>
                      {opt.label}
                    </Option>
                  ))}
                </Select>

                <button
                  onClick={handleRefresh}
                  className="text-black border border-[#DCE3E3] px-2 py-2 rounded-md flex items-center justify-center w-full md:w-auto"
                >
                  <FontAwesomeIcon icon={faRefresh}></FontAwesomeIcon>
                </button>
              </div>
            </div>

            <div className="flex-1 min-h-0 w-full mt-2">
              <ExpenseGraph
                selectedProject={selectedProject}
                selectedMilestone={selectedMilestone}
                selectedDuration={selectedDuration}
                startDate={startDate}
                endDate={endDate}
              />
            </div>
          </div>
        </div>

        {/* User Status Graph */}
        <div className="lg:col-span-5 h-[450px] lg:h-full min-h-0">
          <Admin_UserStatusGraph activeUsers={120} inactiveUsers={80} />
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-2 h-full min-h-0">
        {/* Quick Actions */}
        <div className="lg:col-span-3 h-full min-h-0">
          <QuickActions />
        </div>

        {/* Recent Transactions */}
        <div className="lg:col-span-9 h-full min-h-0">
          <Admin_RecentTransactions />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
